// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.questionnaire_featured__ZH0w\\+ {
  display: flex;
  flex-direction: row;
  flex: 1 1;
  align-items: center;
  align-content: center;
  justify-content: space-between;
}

.questionnaire_featuredItem__97cot {
  flex: 1 1;
  margin: 0px 20px;
  padding: 30px;
  border-radius: 10px;
  cursor: default;
  box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
}

.questionnaire_featuredTitle__Jdcgd {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.questionnaire_featuredTitleHeader__8TllZ {
  font-size: 12px;
}


.questionnaire_featuredTextContainer__jJe4q {
  margin: 10px 0px;
  display: flex;
  align-items: center;
  justify-content: center;

}

.questionnaire_featuredText__30Ryr {
  font-size: 50px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--hsrcOrange);
}


.questionnaire_featuredIcon__xs7td {
  font-size: 14px;
  margin-left: 5px;
  color: green;
}

.questionnaire_featuredIcon__xs7td.questionnaire_negative__HMdhk {
  color: red;
}

.questionnaire_featuredSub__m2K3q {
  font-size: 15px;
  color: gray;
  display: flex;
  align-items: center;
  justify-content: center;
}

.questionnaire_recharts-cartesian-axis-tick__uzktU {
  font-size: 1px !important;
  font-weight: 200;
}


.questionnaire_recharts-cartesian-axis__9z2Eq {
  font-size: 1px !important;
  font-weight: 100;
}

text {
  font-size: 1px;
  font-weight: 200;
}

.questionnaire_dateInputBox__24tw3 {
  width: 100%;
}

.questionnaire_dateInputBoxUpdated__X1-R3 {
  width: 100%;
  background-color: var(--hsrcMidGreen);
}

.questionnaire_textInputBox__G137Q {
  width: 50%;
}

.questionnaire_textInputBoxUpdated__wKEbF {
  width: 50%;
  background-color: var(--hsrcMidGreen);
}

.questionnaire_dropdownBox__41RzM {
  width: 100%;
}

.questionnaire_dropdownBoxUpdated__JE38P {
  width: 100%;
  background-color: var(--hsrcMidGreen);
}

.questionnaire_numericInputBox__-yV1d {
  width: 30%;
}

.questionnaire_numericInputBoxUpdated__EXUFy {
  width: 30%;
  background-color: var(--hsrcMidGreen);
}

.questionnaire_checkbox__qb5wG {}

.questionnaire_checkboxUpdated__1beQR {
  background-color: var(--hsrcMidGreen);
}

.questionnaire_fteTableRowLabelColomn__D8on- {
  width: 20%;
}

.questionnaire_fteTableColomn__1jx5U {
  width: 8%;
}

.questionnaire_fteTableCurrencyColomn__mR9UB {
  width: 13%;
}

.questionnaire_tableInputBox__rvcY2 {
  border: 0px;
  cursor: text;
}

.questionnaire_tableInputBoxUpdated__v1BLJ {
  border: 0px;
  vertical-align: middle;
  align-items: center;
  cursor: text;
  background-color: var(--hsrcMidGreen);
}

.questionnaire_tableInputBoxUpdated__v1BLJ:hover {
  border-radius: 0px;
}

.questionnaire_tableTotalCell__dRBKy {
  width: 100%;
  border: 0px;
  cursor: not-allowed;
}

.questionnaire_tableTotalCellUpdated__dG4I7 {
  border: 0px;
  cursor: not-allowed;
  background-color: var(--hsrcMidGreen);
}

.questionnaire_tableTotalCellUpdated__dG4I7:hover {
  border-radius: 0px;
}

.questionnaire_activitySICQuestionContainer__npCEG {
  width: 80%;
}

.questionnaire_RndOutsourcedQuestionContainer__h4BP4 {
  width: 70%;
}

.questionnaire_SICQuestionContainer__dbTJc {
  width: 80%;
}

.questionnaire_SubsidiaryCompaniesQuestionContainer__AdHnO {
  width: 50%;
}

.questionnaire_RFCodeQuestionContainer__plzcO {
  width: 80%;
}

.questionnaire_SEOCodeQuestionContainer__ztAui {
  width: 80%;
}

.questionnaire_ownershipQuestionContainer__8f4I4 {
  width: 50%;
}

.questionnaire_capitalExpenditureQuestionContainer__CJAeR {
  width: 50%;
}

.questionnaire_fteQuestionContainer__ErcKK {
  width: 100%;
}

.questionnaire_headcountQuestionContainer__nxGIE {
  page-break-inside: avoid;
  break-inside: avoid;
  width: 100%;
}

.questionnaire_questionnaireNavigationBarContainer__PALjw {
  width: 100%;
}

.questionnaire_questionnaireNavigationBarTable__uHG9n {
  width: 100%;
  border: 0px;
}

.questionnaire_questionnaireNavigationBarCell__YCgf\\+ {
  width: 33.3%;
  border: 0px;
}

.questionnaire_heLabourCostQuestionContainer__jjlf9 {
  width: 50%;
}

.questionnaire_breakdownSOFQuestionContainer__hprMm {
  width: 50%;
}

.questionnaire_expenditureLocationQuestionContainer__2\\+ibu {
  width: 30%;
}

.questionnaire_nationalPriorityAreaQuestionContainer__8qgNC {
  width: 38%;
}

.questionnaire_collaborativeRnDQuestionContainer__SUY\\+a {
  width: 100%;
}

.questionnaire_foreignSOFQuestionContainer__Jxxz6 {
  width: 100%;
}

.questionnaire_labourCostTotalQuestionContainer__CWHVJ {
  width: 50%;
}

.questionnaire_editableTotalQuestionContainer__uVefm {
  width: 50%;
}

.questionnaire_futureRndQuestionContainer__fQImp {
  width: 40%;
}

.questionnaire_cellHint__PDPe2 {
  font-family: var(--bookFontFamily);
  margin-left: 0px;
  white-space: pre-wrap;
}

.questionnaire_cellHintUpdated__TBY8E {
  font-family: var(--bookFontFamily);
  margin-left: 0px;
  white-space: pre-wrap;
  background-color: var(--hsrcMidGreen);
}

.questionnaire_cellHintUpdated__TBY8E .questionnaire_tooltiptext__98Jwr {
  font-size: 12px;
  visibility: hidden;
  width: 20%;
  background-color: var(--hsrcLightRed);
  color: var(--hsrcMainRed);
  text-align: left;
  margin-left: 20px;
  padding: 10px;
  border: 1px solid var(--hsrcMainRed);
  box-sizing: border-box;
  border-radius: 5px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
}

.questionnaire_cellHintUpdated__TBY8E:hover .questionnaire_tooltiptext__98Jwr {
  visibility: visible;
}

.questionnaire_cellHintUpdated__TBY8E:hover .questionnaire_tooltiptext__98Jwr {
  visibility: visible;
}

.questionnaire_cellHintUpdated__TBY8E .questionnaire_normalText__C-OPY {
  border-radius: '0px';
  background-color: var(--hsrcMidGreen);
}

.questionnaire_cellHintUpdated__TBY8E .questionnaire_redText__UEomS {
  border: 0px;
  border-radius: '0px';
  color: var(--hsrcMainRed);
}

.questionnaire_cellHintUpdated__TBY8E .questionnaire_redTextUpdated__kkO8V {
  border: 0px;
  border-radius: '0px';
  color: var(--hsrcMainRed);
  background-color: var(--hsrcMidGreen);
}

.questionnaire_cellHint__PDPe2 .questionnaire_tooltiptext__98Jwr {
  font-size: 12px;
  visibility: hidden;
  width: 20%;
  background-color: var(--hsrcLightRed);
  color: var(--hsrcMainRed);
  text-align: left;
  margin-left: 20px;
  padding: 10px;
  border: 1px solid var(--hsrcMainRed);
  box-sizing: border-box;
  border-radius: 5px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
}

.questionnaire_cellHint__PDPe2:hover .questionnaire_tooltiptext__98Jwr {
  visibility: visible;
}

.questionnaire_cellHint__PDPe2 .questionnaire_normalText__C-OPY {
  border-radius: '0px'
}

.questionnaire_cellHint__PDPe2 .questionnaire_redText__UEomS {
  border: 0px;
  border-radius: '0px';
  color: var(--hsrcMainRed);
}

.questionnaire_cellHint__PDPe2 .questionnaire_redTextUpdated__kkO8V {
  border: 0px;
  border-radius: 0px;
  color: var(--hsrcMainRed);
  background-color: var(--hsrcMidGreen);
}

.questionnaire_noClickBox__Ft\\+6B {
  z-index: 10000;
  cursor: not-allowed;
}

.questionnaire_percentage__tReyQ {
  display: inline-block;
  position: relative;
  border: 0px;
}

.questionnaire_percentage__tReyQ input {
  text-align: right;
  padding-right: 25px;
}

.questionnaire_percentage__tReyQ:before {
  content: '%';
  position: absolute;
  right: 5px;
  /* Position the % symbol */
  top: 50%;
  transform: translateY(-50%);
}

.questionnaire_boxItemActive__\\+iOkd {
  border-radius: 15px;
  width: 75px;
  height: 67px;
  font-size: 1.8rem;
  font-weight: bold;
  font-family: var(--bookFontFamily);
  line-height: 1;
  text-align: center;
  padding: 1rem;
  background: var(--hsrcOrange);
  border: 3px solid var(--hsrcOrange);
  color: #fff;
  margin: 6px;
}

.questionnaire_boxItem__zq06B {
  border-radius: 15px;
  width: 75px;
  height: 67px;
  font-size: 1.8rem;
  font-weight: bold;
  font-family: var(--bookFontFamily);
  line-height: 1;
  text-align: center;
  padding: 1rem;
  background: #fff;
  border: 3px solid #ccc;
  color: #ccc;
  margin: 6px;
}

.questionnaire_belowTitleText__m6nKQ {
  font-family: var(--bookFontFamily);
  color: var(--hsrcMidBlue);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
  letter-spacing: 0.07em;
  text-align: left;
}

.questionnaire_partTitle__ItbIp {
  font-family: var(--bookFontFamily);
  font-size: 25px;
  line-height: 63px;
  letter-spacing: 0.07em;
  text-align: left;
}

.questionnaire_compoundQuestionStateTitle__25B5s {
  font-family: var(--bookFontFamily);
  font-size: 20px;
  line-height: 63px;
  letter-spacing: 0.07em;
  text-align: left;
}

.questionnaire_pagebreak__F71qa {
  page-break-after: always;
}

.questionnaire_avoidbreak_inside__\\+Nub- {
  page-break-inside: avoid;
  break-inside: avoid;
}

.questionnaire_endOfBoxInput__1Y8hz {
  text-align-last: right;
}

/* Style the modal */
.questionnaire_modal__Z2wy4 {
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  background-color: rgba(0, 0, 0, 0.4);
  /* Semi-transparent black background */
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Modal Content */
.questionnaire_modal_content__u-sF4 {
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  border-radius: 5px;
  display: flex;
  align-items: center;
  box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2);
  background-color: #fefefe;
}

.questionnaire_modal_text__FJWk- {
  margin-left: 14px;
  font-size: 24px;
}

.questionnaire_updateAuditDialog__zjWXb {
  min-width: 40vw !important;
  max-width: 40vw !important;
}

.questionnaire_updateAuditDialogOverlay__Uca6w {
  display: flexbox;
  z-index: 10000;
}

.questionnaire_flexCenterFitContent__9dWPJ {
  display: flex;
  align-items: center;
  max-width: fit-content;
}

.questionnaire_centerAlignVertically__n-nBU {
  vertical-align: middle;
  align-items: center;
}

/* Create the circle loader with pure CSS */
.questionnaire_loader__B0Yeb {
  width: 50px;
  height: 50px;
  border: 8px solid #ddd;
  border-top: 8px solid #2196f3;
  border-bottom: 8px solid #2196f3;
  border-radius: 50%;
  animation: questionnaire_spin__ZFh49 2s linear infinite;
}

@keyframes questionnaire_spin__ZFh49 {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Questionnaire/questionnaire.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EAEf,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;AAEzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;;AAGA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,qCAAqC;AACvC;;AAEA,gCAAW;;AAEX;EACE,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,qCAAqC;EACrC,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;;EAElB,oDAAoD;EACpD,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,qCAAqC;EACrC,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;;EAElB,oDAAoD;EACpD,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,0BAA0B;EAC1B,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,mCAAmC;EACnC,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,OAAO;EACP,MAAM;EACN,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAElB,uDAAkC;AACpC;;AAYA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".featured {\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex: 1;\r\n  align-items: center;\r\n  align-content: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.featuredItem {\r\n  flex: 1;\r\n  margin: 0px 20px;\r\n  padding: 30px;\r\n  border-radius: 10px;\r\n  cursor: default;\r\n  -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n  box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.featuredTitle {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 20px;\r\n}\r\n\r\n.featuredTitleHeader {\r\n  font-size: 12px;\r\n}\r\n\r\n\r\n.featuredTextContainer {\r\n  margin: 10px 0px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n}\r\n\r\n.featuredText {\r\n  font-size: 50px;\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--hsrcOrange);\r\n}\r\n\r\n\r\n.featuredIcon {\r\n  font-size: 14px;\r\n  margin-left: 5px;\r\n  color: green;\r\n}\r\n\r\n.featuredIcon.negative {\r\n  color: red;\r\n}\r\n\r\n.featuredSub {\r\n  font-size: 15px;\r\n  color: gray;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.recharts-cartesian-axis-tick {\r\n  font-size: 1px !important;\r\n  font-weight: 200;\r\n}\r\n\r\n\r\n.recharts-cartesian-axis {\r\n  font-size: 1px !important;\r\n  font-weight: 100;\r\n}\r\n\r\ntext {\r\n  font-size: 1px;\r\n  font-weight: 200;\r\n}\r\n\r\n.dateInputBox {\r\n  width: 100%;\r\n}\r\n\r\n.dateInputBoxUpdated {\r\n  width: 100%;\r\n  background-color: var(--hsrcMidGreen);\r\n}\r\n\r\n.textInputBox {\r\n  width: 50%;\r\n}\r\n\r\n.textInputBoxUpdated {\r\n  width: 50%;\r\n  background-color: var(--hsrcMidGreen);\r\n}\r\n\r\n.dropdownBox {\r\n  width: 100%;\r\n}\r\n\r\n.dropdownBoxUpdated {\r\n  width: 100%;\r\n  background-color: var(--hsrcMidGreen);\r\n}\r\n\r\n.numericInputBox {\r\n  width: 30%;\r\n}\r\n\r\n.numericInputBoxUpdated {\r\n  width: 30%;\r\n  background-color: var(--hsrcMidGreen);\r\n}\r\n\r\n.checkbox {}\r\n\r\n.checkboxUpdated {\r\n  background-color: var(--hsrcMidGreen);\r\n}\r\n\r\n.fteTableRowLabelColomn {\r\n  width: 20%;\r\n}\r\n\r\n.fteTableColomn {\r\n  width: 8%;\r\n}\r\n\r\n.fteTableCurrencyColomn {\r\n  width: 13%;\r\n}\r\n\r\n.tableInputBox {\r\n  border: 0px;\r\n  cursor: text;\r\n}\r\n\r\n.tableInputBoxUpdated {\r\n  border: 0px;\r\n  vertical-align: middle;\r\n  align-items: center;\r\n  cursor: text;\r\n  background-color: var(--hsrcMidGreen);\r\n}\r\n\r\n.tableInputBoxUpdated:hover {\r\n  border-radius: 0px;\r\n}\r\n\r\n.tableTotalCell {\r\n  width: 100%;\r\n  border: 0px;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.tableTotalCellUpdated {\r\n  border: 0px;\r\n  cursor: not-allowed;\r\n  background-color: var(--hsrcMidGreen);\r\n}\r\n\r\n.tableTotalCellUpdated:hover {\r\n  border-radius: 0px;\r\n}\r\n\r\n.activitySICQuestionContainer {\r\n  width: 80%;\r\n}\r\n\r\n.RndOutsourcedQuestionContainer {\r\n  width: 70%;\r\n}\r\n\r\n.SICQuestionContainer {\r\n  width: 80%;\r\n}\r\n\r\n.SubsidiaryCompaniesQuestionContainer {\r\n  width: 50%;\r\n}\r\n\r\n.RFCodeQuestionContainer {\r\n  width: 80%;\r\n}\r\n\r\n.SEOCodeQuestionContainer {\r\n  width: 80%;\r\n}\r\n\r\n.ownershipQuestionContainer {\r\n  width: 50%;\r\n}\r\n\r\n.capitalExpenditureQuestionContainer {\r\n  width: 50%;\r\n}\r\n\r\n.fteQuestionContainer {\r\n  width: 100%;\r\n}\r\n\r\n.headcountQuestionContainer {\r\n  break-inside: avoid;\r\n  width: 100%;\r\n}\r\n\r\n.questionnaireNavigationBarContainer {\r\n  width: 100%;\r\n}\r\n\r\n.questionnaireNavigationBarTable {\r\n  width: 100%;\r\n  border: 0px;\r\n}\r\n\r\n.questionnaireNavigationBarCell {\r\n  width: 33.3%;\r\n  border: 0px;\r\n}\r\n\r\n.heLabourCostQuestionContainer {\r\n  width: 50%;\r\n}\r\n\r\n.breakdownSOFQuestionContainer {\r\n  width: 50%;\r\n}\r\n\r\n.expenditureLocationQuestionContainer {\r\n  width: 30%;\r\n}\r\n\r\n.nationalPriorityAreaQuestionContainer {\r\n  width: 38%;\r\n}\r\n\r\n.collaborativeRnDQuestionContainer {\r\n  width: 100%;\r\n}\r\n\r\n.foreignSOFQuestionContainer {\r\n  width: 100%;\r\n}\r\n\r\n.labourCostTotalQuestionContainer {\r\n  width: 50%;\r\n}\r\n\r\n.editableTotalQuestionContainer {\r\n  width: 50%;\r\n}\r\n\r\n.futureRndQuestionContainer {\r\n  width: 40%;\r\n}\r\n\r\n.cellHint {\r\n  font-family: var(--bookFontFamily);\r\n  margin-left: 0px;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.cellHintUpdated {\r\n  font-family: var(--bookFontFamily);\r\n  margin-left: 0px;\r\n  white-space: pre-wrap;\r\n  background-color: var(--hsrcMidGreen);\r\n}\r\n\r\n.cellHintUpdated .tooltiptext {\r\n  font-size: 12px;\r\n  visibility: hidden;\r\n  width: 20%;\r\n  background-color: var(--hsrcLightRed);\r\n  color: var(--hsrcMainRed);\r\n  text-align: left;\r\n  margin-left: 20px;\r\n  padding: 10px;\r\n  border: 1px solid var(--hsrcMainRed);\r\n  box-sizing: border-box;\r\n  border-radius: 5px;\r\n\r\n  /* Position the tooltip text - see examples below! */\r\n  position: absolute;\r\n  z-index: 1;\r\n}\r\n\r\n.cellHintUpdated:hover .tooltiptext {\r\n  visibility: visible;\r\n}\r\n\r\n.cellHintUpdated:hover .tooltiptext {\r\n  visibility: visible;\r\n}\r\n\r\n.cellHintUpdated .normalText {\r\n  border-radius: '0px';\r\n  background-color: var(--hsrcMidGreen);\r\n}\r\n\r\n.cellHintUpdated .redText {\r\n  border: 0px;\r\n  border-radius: '0px';\r\n  color: var(--hsrcMainRed);\r\n}\r\n\r\n.cellHintUpdated .redTextUpdated {\r\n  border: 0px;\r\n  border-radius: '0px';\r\n  color: var(--hsrcMainRed);\r\n  background-color: var(--hsrcMidGreen);\r\n}\r\n\r\n.cellHint .tooltiptext {\r\n  font-size: 12px;\r\n  visibility: hidden;\r\n  width: 20%;\r\n  background-color: var(--hsrcLightRed);\r\n  color: var(--hsrcMainRed);\r\n  text-align: left;\r\n  margin-left: 20px;\r\n  padding: 10px;\r\n  border: 1px solid var(--hsrcMainRed);\r\n  box-sizing: border-box;\r\n  border-radius: 5px;\r\n\r\n  /* Position the tooltip text - see examples below! */\r\n  position: absolute;\r\n  z-index: 1;\r\n}\r\n\r\n.cellHint:hover .tooltiptext {\r\n  visibility: visible;\r\n}\r\n\r\n.cellHint .normalText {\r\n  border-radius: '0px'\r\n}\r\n\r\n.cellHint .redText {\r\n  border: 0px;\r\n  border-radius: '0px';\r\n  color: var(--hsrcMainRed);\r\n}\r\n\r\n.cellHint .redTextUpdated {\r\n  border: 0px;\r\n  border-radius: 0px;\r\n  color: var(--hsrcMainRed);\r\n  background-color: var(--hsrcMidGreen);\r\n}\r\n\r\n.noClickBox {\r\n  z-index: 10000;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.percentage {\r\n  display: inline-block;\r\n  position: relative;\r\n  border: 0px;\r\n}\r\n\r\n.percentage input {\r\n  text-align: right;\r\n  padding-right: 25px;\r\n}\r\n\r\n.percentage:before {\r\n  content: '%';\r\n  position: absolute;\r\n  right: 5px;\r\n  /* Position the % symbol */\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.boxItemActive {\r\n  border-radius: 15px;\r\n  width: 75px;\r\n  height: 67px;\r\n  font-size: 1.8rem;\r\n  font-weight: bold;\r\n  font-family: var(--bookFontFamily);\r\n  line-height: 1;\r\n  text-align: center;\r\n  padding: 1rem;\r\n  background: var(--hsrcOrange);\r\n  border: 3px solid var(--hsrcOrange);\r\n  color: #fff;\r\n  margin: 6px;\r\n}\r\n\r\n.boxItem {\r\n  border-radius: 15px;\r\n  width: 75px;\r\n  height: 67px;\r\n  font-size: 1.8rem;\r\n  font-weight: bold;\r\n  font-family: var(--bookFontFamily);\r\n  line-height: 1;\r\n  text-align: center;\r\n  padding: 1rem;\r\n  background: #fff;\r\n  border: 3px solid #ccc;\r\n  color: #ccc;\r\n  margin: 6px;\r\n}\r\n\r\n.belowTitleText {\r\n  font-family: var(--bookFontFamily);\r\n  color: var(--hsrcMidBlue);\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 36px;\r\n  letter-spacing: 0.07em;\r\n  text-align: left;\r\n}\r\n\r\n.partTitle {\r\n  font-family: var(--bookFontFamily);\r\n  font-size: 25px;\r\n  line-height: 63px;\r\n  letter-spacing: 0.07em;\r\n  text-align: left;\r\n}\r\n\r\n.compoundQuestionStateTitle {\r\n  font-family: var(--bookFontFamily);\r\n  font-size: 20px;\r\n  line-height: 63px;\r\n  letter-spacing: 0.07em;\r\n  text-align: left;\r\n}\r\n\r\n.pagebreak {\r\n  page-break-after: always;\r\n}\r\n\r\n.avoidbreak_inside {\r\n  break-inside: avoid;\r\n}\r\n\r\n.endOfBoxInput {\r\n  text-align-last: right;\r\n}\r\n\r\n/* Style the modal */\r\n.modal {\r\n  position: fixed;\r\n  /* Stay in place */\r\n  z-index: 1;\r\n  /* Sit on top */\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  /* Full width */\r\n  height: 100%;\r\n  /* Full height */\r\n  background-color: rgba(0, 0, 0, 0.4);\r\n  /* Semi-transparent black background */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n/* Modal Content */\r\n.modal_content {\r\n  margin: auto;\r\n  padding: 20px;\r\n  border: 1px solid #888;\r\n  border-radius: 5px;\r\n  display: flex;\r\n  align-items: center;\r\n  box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2);\r\n  background-color: #fefefe;\r\n}\r\n\r\n.modal_text {\r\n  margin-left: 14px;\r\n  font-size: 24px;\r\n}\r\n\r\n.updateAuditDialog {\r\n  min-width: 40vw !important;\r\n  max-width: 40vw !important;\r\n}\r\n\r\n.updateAuditDialogOverlay {\r\n  display: flexbox;\r\n  z-index: 10000;\r\n}\r\n\r\n.flexCenterFitContent {\r\n  display: flex;\r\n  align-items: center;\r\n  max-width: fit-content;\r\n}\r\n\r\n.centerAlignVertically {\r\n  vertical-align: middle;\r\n  align-items: center;\r\n}\r\n\r\n/* Create the circle loader with pure CSS */\r\n.loader {\r\n  width: 50px;\r\n  height: 50px;\r\n  border: 8px solid #ddd;\r\n  border-top: 8px solid #2196f3;\r\n  border-bottom: 8px solid #2196f3;\r\n  border-radius: 50%;\r\n  -webkit-animation: spin 2s linear infinite;\r\n  animation: spin 2s linear infinite;\r\n}\r\n\r\n@-webkit-keyframes spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featured": `questionnaire_featured__ZH0w+`,
	"featuredItem": `questionnaire_featuredItem__97cot`,
	"featuredTitle": `questionnaire_featuredTitle__Jdcgd`,
	"featuredTitleHeader": `questionnaire_featuredTitleHeader__8TllZ`,
	"featuredTextContainer": `questionnaire_featuredTextContainer__jJe4q`,
	"featuredText": `questionnaire_featuredText__30Ryr`,
	"featuredIcon": `questionnaire_featuredIcon__xs7td`,
	"negative": `questionnaire_negative__HMdhk`,
	"featuredSub": `questionnaire_featuredSub__m2K3q`,
	"recharts-cartesian-axis-tick": `questionnaire_recharts-cartesian-axis-tick__uzktU`,
	"recharts-cartesian-axis": `questionnaire_recharts-cartesian-axis__9z2Eq`,
	"dateInputBox": `questionnaire_dateInputBox__24tw3`,
	"dateInputBoxUpdated": `questionnaire_dateInputBoxUpdated__X1-R3`,
	"textInputBox": `questionnaire_textInputBox__G137Q`,
	"textInputBoxUpdated": `questionnaire_textInputBoxUpdated__wKEbF`,
	"dropdownBox": `questionnaire_dropdownBox__41RzM`,
	"dropdownBoxUpdated": `questionnaire_dropdownBoxUpdated__JE38P`,
	"numericInputBox": `questionnaire_numericInputBox__-yV1d`,
	"numericInputBoxUpdated": `questionnaire_numericInputBoxUpdated__EXUFy`,
	"checkbox": `questionnaire_checkbox__qb5wG`,
	"checkboxUpdated": `questionnaire_checkboxUpdated__1beQR`,
	"fteTableRowLabelColomn": `questionnaire_fteTableRowLabelColomn__D8on-`,
	"fteTableColomn": `questionnaire_fteTableColomn__1jx5U`,
	"fteTableCurrencyColomn": `questionnaire_fteTableCurrencyColomn__mR9UB`,
	"tableInputBox": `questionnaire_tableInputBox__rvcY2`,
	"tableInputBoxUpdated": `questionnaire_tableInputBoxUpdated__v1BLJ`,
	"tableTotalCell": `questionnaire_tableTotalCell__dRBKy`,
	"tableTotalCellUpdated": `questionnaire_tableTotalCellUpdated__dG4I7`,
	"activitySICQuestionContainer": `questionnaire_activitySICQuestionContainer__npCEG`,
	"RndOutsourcedQuestionContainer": `questionnaire_RndOutsourcedQuestionContainer__h4BP4`,
	"SICQuestionContainer": `questionnaire_SICQuestionContainer__dbTJc`,
	"SubsidiaryCompaniesQuestionContainer": `questionnaire_SubsidiaryCompaniesQuestionContainer__AdHnO`,
	"RFCodeQuestionContainer": `questionnaire_RFCodeQuestionContainer__plzcO`,
	"SEOCodeQuestionContainer": `questionnaire_SEOCodeQuestionContainer__ztAui`,
	"ownershipQuestionContainer": `questionnaire_ownershipQuestionContainer__8f4I4`,
	"capitalExpenditureQuestionContainer": `questionnaire_capitalExpenditureQuestionContainer__CJAeR`,
	"fteQuestionContainer": `questionnaire_fteQuestionContainer__ErcKK`,
	"headcountQuestionContainer": `questionnaire_headcountQuestionContainer__nxGIE`,
	"questionnaireNavigationBarContainer": `questionnaire_questionnaireNavigationBarContainer__PALjw`,
	"questionnaireNavigationBarTable": `questionnaire_questionnaireNavigationBarTable__uHG9n`,
	"questionnaireNavigationBarCell": `questionnaire_questionnaireNavigationBarCell__YCgf+`,
	"heLabourCostQuestionContainer": `questionnaire_heLabourCostQuestionContainer__jjlf9`,
	"breakdownSOFQuestionContainer": `questionnaire_breakdownSOFQuestionContainer__hprMm`,
	"expenditureLocationQuestionContainer": `questionnaire_expenditureLocationQuestionContainer__2+ibu`,
	"nationalPriorityAreaQuestionContainer": `questionnaire_nationalPriorityAreaQuestionContainer__8qgNC`,
	"collaborativeRnDQuestionContainer": `questionnaire_collaborativeRnDQuestionContainer__SUY+a`,
	"foreignSOFQuestionContainer": `questionnaire_foreignSOFQuestionContainer__Jxxz6`,
	"labourCostTotalQuestionContainer": `questionnaire_labourCostTotalQuestionContainer__CWHVJ`,
	"editableTotalQuestionContainer": `questionnaire_editableTotalQuestionContainer__uVefm`,
	"futureRndQuestionContainer": `questionnaire_futureRndQuestionContainer__fQImp`,
	"cellHint": `questionnaire_cellHint__PDPe2`,
	"cellHintUpdated": `questionnaire_cellHintUpdated__TBY8E`,
	"tooltiptext": `questionnaire_tooltiptext__98Jwr`,
	"normalText": `questionnaire_normalText__C-OPY`,
	"redText": `questionnaire_redText__UEomS`,
	"redTextUpdated": `questionnaire_redTextUpdated__kkO8V`,
	"noClickBox": `questionnaire_noClickBox__Ft+6B`,
	"percentage": `questionnaire_percentage__tReyQ`,
	"boxItemActive": `questionnaire_boxItemActive__+iOkd`,
	"boxItem": `questionnaire_boxItem__zq06B`,
	"belowTitleText": `questionnaire_belowTitleText__m6nKQ`,
	"partTitle": `questionnaire_partTitle__ItbIp`,
	"compoundQuestionStateTitle": `questionnaire_compoundQuestionStateTitle__25B5s`,
	"pagebreak": `questionnaire_pagebreak__F71qa`,
	"avoidbreak_inside": `questionnaire_avoidbreak_inside__+Nub-`,
	"endOfBoxInput": `questionnaire_endOfBoxInput__1Y8hz`,
	"modal": `questionnaire_modal__Z2wy4`,
	"modal_content": `questionnaire_modal_content__u-sF4`,
	"modal_text": `questionnaire_modal_text__FJWk-`,
	"updateAuditDialog": `questionnaire_updateAuditDialog__zjWXb`,
	"updateAuditDialogOverlay": `questionnaire_updateAuditDialogOverlay__Uca6w`,
	"flexCenterFitContent": `questionnaire_flexCenterFitContent__9dWPJ`,
	"centerAlignVertically": `questionnaire_centerAlignVertically__n-nBU`,
	"loader": `questionnaire_loader__B0Yeb`,
	"spin": `questionnaire_spin__ZFh49`
};
export default ___CSS_LOADER_EXPORT___;
